<div class="mat-table-global">
  <table
    [dataSource]="dataSource"
    mat-table
    matSort
    matTableResponsive
    multiTemplateDataRows
    id="workorder-list-table">
    <ng-container matColumnDef="serviceAccountName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Site Name</th>
      <td mat-cell *matCellDef="let element">
        {{ element.serviceAccountName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="requestType">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Request Type</th>
      <td mat-cell *matCellDef="let element">{{ element.requestType }}</td>
    </ng-container>

    <ng-container matColumnDef="workOrderNumber">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Work Order No.</th>
      <td mat-cell *matCellDef="let element">
        {{ element.workOrderNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="confirmedServiceDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        Confirmed Service Date
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.confirmedServiceDate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="serviceDetails">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Service Details</th>
      <td mat-cell *matCellDef="let element">
        <span [matTooltip]="element.serviceDetails" matTooltipPosition="right">
          {{ element.serviceDetails }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="systemStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Booking Status</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip disableRipple [ngClass]="element.systemStatus">
          {{ element.systemStatus }}
        </mat-chip>
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th class="action-column text-center" mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td class="action-column" mat-cell *matCellDef="let element">
        <div
          class="action-icon-container"
          (click)="workOrderSelected(element.workOrderId)">
          <img src="../assets/images/visibility.svg" alt="View" />
        </div>
      </td>
    </ng-container>

    <tr
      class="table-header-row"
      mat-header-row
      *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-data-row"
      mat-row
      *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    class="table-paginator-row"
    [pageSizeOptions]="[5, 10, 15]"
    showFirstLastButtons></mat-paginator>
</div>
